//imports
import {
    DEALERS_CREATE_EDIT_DEALER_OPEN_MODAL,
    DEALERS_CREATE_EDIT_DEALER_CLOSE_MODAL,
    DEALERS_CREATE_DEALER_REQUEST,
    DEALERS_CREATE_DEALER_RESULT,
    DEALERS_EDIT_DEALER_REQUEST,
    DEALERS_EDIT_DEALER_RESULT,
    DEALERS_CREATE_EDIT_DEALER_SEARCH_ROLES_REQUEST,
    DEALERS_CREATE_EDIT_DEALER_SEARCH_ROLES_RESULT,
    DEALERS_CREATE_EDIT_DEALER_GET_ROLE_REQUEST,
    DEALERS_CREATE_EDIT_DEALER_GET_ROLE_RESULT,
    DEALERS_CREATE_EDIT_DEALER_GET_DEALER_REQUEST,
    DEALERS_CREATE_EDIT_DEALER_GET_DEALER_RESULT,
    DEALERS_CREATE_EDIT_DEALER_GET_CUSTOM_ROLE_REQUEST,
    DEALERS_CREATE_EDIT_DEALER_GET_CUSTOM_ROLE_RESULT,
    DEALERS_CREATE_EDIT_DEALER_GET_ROLE_MODULES_TEMPLATE_REQUEST,
    DEALERS_CREATE_EDIT_DEALER_GET_ROLE_MODULES_TEMPLATE_RESULT,
    DEALERS_CREATE_EDIT_DEALER_SEARCH_TIMEZONES_RESULT,
    DEALERS_CREATE_EDIT_DEALER_SEARCH_TIMEZONES_REQUEST,
    DEALERS_CREDENCIAL_VALIDATION_REQUEST,
    DEALERS_CREDENCIAL_VALIDATION_RESULT,
    CLEAR_REDUX,
} from 'Redux/actionTypes';

//initial values
const INIT_STATE = {
    createDealer: null,
    editDealer: null,
    loading: false,
    openModal: false,
    rolesLoading: false,
    roles: [],
    roleLoading: false,
    role: null,
    dealer: null,
    resultDealer: null,
    resultDealerLoading: false,
    roleModuleLoading: false,
    customRole: null,
    customRoleLoading: false,
    roleModuleTemplate: [],
    roleModuleTemplateLoading: false,
    timeZones: [],
    timeZonesLoading: false,
    credentialValidation: null,
};


//change redux object
export default (state = INIT_STATE, action) => {
    switch (action.type) {

        case DEALERS_CREATE_EDIT_DEALER_GET_ROLE_MODULES_TEMPLATE_REQUEST:
            return { ...state, roleModuleTemplateLoading: true }

        case DEALERS_CREATE_EDIT_DEALER_GET_ROLE_MODULES_TEMPLATE_RESULT:
            return { ...state, roleModuleTemplateLoading: false, roleModuleTemplate: action.payload }

        case DEALERS_CREATE_EDIT_DEALER_OPEN_MODAL:
            return { ...state, openModal: true, dealer: action.payload }

        case DEALERS_CREATE_EDIT_DEALER_CLOSE_MODAL:
            return { ...state, openModal: false }

        case DEALERS_CREATE_DEALER_REQUEST:
            return { ...state, loading: true }

        case DEALERS_CREATE_DEALER_RESULT:
            return { ...state, loading: false, createDealer: action.payload }

        case DEALERS_EDIT_DEALER_REQUEST:
            return { ...state, loading: true }

        case DEALERS_EDIT_DEALER_RESULT:
            return { ...state, loading: false, editDealer: action.payload }

        case DEALERS_CREATE_EDIT_DEALER_SEARCH_ROLES_REQUEST:
            return { ...state, rolesLoading: true }

        case DEALERS_CREATE_EDIT_DEALER_SEARCH_ROLES_RESULT:
            return { ...state, rolesLoading: false, roles: action.payload }

        case DEALERS_CREATE_EDIT_DEALER_GET_ROLE_REQUEST:
            return { ...state, roleModuleLoading: true }

        case DEALERS_CREATE_EDIT_DEALER_GET_ROLE_RESULT:
            return { ...state, roleModuleLoading: false, role: action.payload }

        case DEALERS_CREATE_EDIT_DEALER_GET_DEALER_REQUEST:
            return { ...state, resultDealerLoading: true }

        case DEALERS_CREATE_EDIT_DEALER_GET_DEALER_RESULT:
            return { ...state, resultDealer: action.payload, resultDealerLoading: false }

        case DEALERS_CREATE_EDIT_DEALER_GET_CUSTOM_ROLE_REQUEST:
            return { ...state, customRoleLoading: true }

        case DEALERS_CREATE_EDIT_DEALER_GET_CUSTOM_ROLE_RESULT:
            return { ...state, customRoleLoading: false, customRole: action.payload }

        case DEALERS_CREATE_EDIT_DEALER_SEARCH_TIMEZONES_REQUEST:
            return { ...state, timeZonesLoading: true }

        case DEALERS_CREATE_EDIT_DEALER_SEARCH_TIMEZONES_RESULT:
            return { ...state, timeZones: action.payload, timeZonesLoading: false }

        case DEALERS_CREDENCIAL_VALIDATION_REQUEST:
            return { ...state, loading: true }

        case DEALERS_CREDENCIAL_VALIDATION_RESULT:
            return { ...state, loading: false, credentialValidation: action.payload }

        case CLEAR_REDUX:
            return ["", "CREATE_EDIT_DEALER"].includes(action.payload.option)
                ? action.payload.parameters
                    ? { ...state, ...action.payload.parameters }
                    : { ...INIT_STATE }
                : { ...state };

        default:
            return state;
    }
};